/**
 *
 * @param title
 */
function setViewPageTitle(title) {
  window.callBridge && window.callBridge('setViewPageTitle', title, function(response) {});
}

export default setViewPageTitle;
